import React, { Component } from "react";
import Modal from "@material-ui/core/Modal";
import styled from "styled-components";

import {
  MUIButton,
  MUIFormControl,
  MUITextField
} from "../../../../components/Mui";
import { white } from "../../../../styles/colors";

const FieldSet = styled.fieldset`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 8px 16px 12px;
  margin-top: 16px;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
`;

const Legend = styled.legend`
  font-weight: 600;
  font-size: 11px;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 6px;
  white-space: nowrap;
`;

const ModalContent = styled.div`
  max-width: 340px;
  margin: auto;
  background-color: ${white};
  padding: 30px 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  outline: none;
`;

const ModalTitle = styled.h3`
  text-align: center;
  margin: 0 0 20px;
`;

const ModalButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  
  & > button {
    margin: 10px!important;
  }
`;

const ProgressText = styled.p`
  text-align: center;
  margin: 10px 0 0;
  font-size: 13px;
  color: #666;
`;

class BulkDeleteBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromId: "",
      toId: "",
      confirmOpen: false,
      deleting: false,
      progress: 0,
      total: 0
    };
  }

  handleConfirmOpen = () => {
    const { fromId, toId } = this.state;
    const from = parseInt(fromId, 10);
    const to = parseInt(toId, 10);

    if (!from || !to || from > to) return;

    this.setState({ confirmOpen: true });
  };

  handleConfirmClose = () => {
    if (this.state.deleting) return;
    this.setState({ confirmOpen: false });
  };

  handleBulkDelete = async () => {
    const { deleteUser } = this.props;
    const { fromId, toId } = this.state;
    const from = parseInt(fromId, 10);
    const to = parseInt(toId, 10);
    const total = to - from + 1;

    this.setState({ deleting: true, progress: 0, total });

    for (let id = from; id <= to; id++) {
      await new Promise((resolve) => {
        deleteUser({
          id,
          onSuccess: () => resolve(),
          onError: () => resolve()
        });

        // Give saga time to process
        setTimeout(resolve, 1500);
      });

      this.setState({ progress: id - from + 1 });
    }

    this.setState({
      deleting: false,
      confirmOpen: false,
      fromId: "",
      toId: ""
    });

    // Reload to reflect changes
    window.location.reload();
  };

  render() {
    const { fromId, toId, confirmOpen, deleting, progress, total } = this.state;
    const from = parseInt(fromId, 10);
    const to = parseInt(toId, 10);
    const isValid = from && to && from <= to;
    const count = isValid ? to - from + 1 : 0;

    return (
      <>
        <FieldSet>
          <Legend>Bulk Delete</Legend>

          <MUIFormControl style={{ minWidth: 'auto' }}>
            <MUITextField
              label="From ID"
              type="number"
              value={fromId}
              onChange={(e) => this.setState({ fromId: e.target.value })}
              style={{ width: 100 }}
            />
          </MUIFormControl>

          <MUIFormControl style={{ minWidth: 'auto' }}>
            <MUITextField
              label="To ID"
              type="number"
              value={toId}
              onChange={(e) => this.setState({ toId: e.target.value })}
              style={{ width: 100 }}
            />
          </MUIFormControl>

          <MUIButton
            type="button"
            size="medium"
            variant="contained"
            color="secondary"
            disabled={!isValid}
            onClick={this.handleConfirmOpen}
          >
            Delete {isValid ? `(${count} users)` : ''}
          </MUIButton>
        </FieldSet>

        <Modal
          open={confirmOpen}
          onClose={this.handleConfirmClose}
        >
          <ModalContent>
            <ModalTitle>
              {deleting
                ? `Deleting users... ${progress}/${total}`
                : `Delete ${count} users (ID ${fromId} to ${toId})?`
              }
            </ModalTitle>

            {deleting && (
              <ProgressText>
                Please wait, do not close this window.
              </ProgressText>
            )}

            {!deleting && (
              <ModalButtons>
                <MUIButton
                  size="medium"
                  variant="contained"
                  type="button"
                  color="secondary"
                  onClick={this.handleBulkDelete}
                >
                  Confirm Delete
                </MUIButton>

                <MUIButton
                  size="medium"
                  variant="contained"
                  type="button"
                  onClick={this.handleConfirmClose}
                >
                  Cancel
                </MUIButton>
              </ModalButtons>
            )}
          </ModalContent>
        </Modal>
      </>
    );
  }
}

export default BulkDeleteBar;
